// extracted by mini-css-extract-plugin
export default {"content":"ContactScreen_content__XTZih","link":"ContactScreen_link__ovhG7"};